<div class="u-flex-column u-margin-top">
    <app-info-block [label]="'ADMIN.DASHBOARD.DETAIL.WATER_DETAILS.FINAL_INVOICE' | translate">
        <app-info-detail [label]="'V2.SERVICES.WATER.FILING_OPTIONS.PREFERENCE' | translate">
            @if (waterFinalInvoiceService?.active) {
                @if (waterFinalInvoiceService?.filingOption?.filingType) {
                    <span class="u-color-success">{{
                        'V2.SERVICES.WATER.FILING_OPTIONS.' +
                            (waterFinalInvoiceService.filingOption?.filingType | camelCaseToUpperSnakeCase) +
                            '.LABEL' | translate
                    }}</span>
                } @else {
                    <span class="u-color-success">{{ 'V2.SERVICES.WATER.FILING_OPTIONS.SMOOVED.LABEL' | translate }} (Default)</span>
                }
            } @else {
                <span class="u-color-error">{{ 'SERVICE_ACTIVE.FALSE' | translate }}</span>
            }
        </app-info-detail>
        <app-info-detail [label]="'ADMIN.DASHBOARD.DETAIL.WATER_DETAILS.BY_POST' | translate">
            @if (waterTransferDocumentService?.leaverFinalInvoiceByPost) {
                <span class="u-color-success">{{ 'YES' | translate }}</span>
            } @else {
                <span class="u-color-error">{{ 'NO' | translate }}</span>
            }
        </app-info-detail>
        <app-info-detail [label]="'ADMIN.DASHBOARD.DETAIL.WATER_DETAILS.CONTACT_ADDRESS' | translate">
            <p [unknownIfEmpty]="leaver?.user?.formattedContactAddress"></p>
        </app-info-detail>
    </app-info-block>
    <app-info-block [label]="'ADMIN.DASHBOARD.DETAIL.WATER_DETAILS.NEW_CONTRACT' | translate">
        <app-info-detail [label]="'ADMIN.DASHBOARD.DETAIL.WATER_DETAILS.NEW_CONTRACT_FOR_TRANSFEREE' | translate">
            @if (waterNewContractService?.active) {
                <span class="u-color-success">{{ 'YES' | translate }}</span>
            } @else {
                <span class="u-color-error">{{ 'NO' | translate }}</span>
            }
        </app-info-detail>
        <app-info-detail [label]="'ADMIN.DASHBOARD.DETAIL.WATER_DETAILS.NATIONAL_REGISTRATION_NUMBER' | translate">
            <p [unknownIfEmpty]="transferee?.user?.nationalRegistrationNumber"></p>
        </app-info-detail>
    </app-info-block>
</div>
